module.exports = __webpack_public_path__ + "img/recommendation_checkmark.04fd8274.svg";